import { InstallmentFeesFields } from '@/components/InstallmentFeesFields';
/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react';
import { ButtonGroup, InputText } from '@/components';
import { Form, FormGroup } from 'reactstrap';
import { updateMask } from '@/helpers/masks/cashNumber';
import { SectorProductContainerProps } from '../../screens/ui';
import { RegisterDiscountCoupon } from '../RegisterDiscountCoupon';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  physicalSaleDebit = 'physicalSaleDebit',
  physicalSaleCredit = 'physicalSaleCredit',
  physicalSalePix = 'physicalSalePix',
  physicalSaleAdministrateTax = 'physicalSaleAdministrateTax',
  physicalSaleInstallmentFees = 'physicalSaleInstallmentFees',

  websiteSaleCredit = 'websiteSaleCredit',
  websiteSalePix = 'websiteSalePix',
  websiteSaleAdministrateTax = 'websiteSaleAdministrateTax',
  websiteSaleInstallmentFees = 'websiteSaleInstallmentFees',

  allowDiscountCoupon = 'allowDiscountCoupon',
  partialPayment = 'partialPayment',
  waiter = 'waiter',
  websiteSaleBankSlip = 'websiteSaleBankSlip',
}

export const ProductConfigContent: React.FC<
  Pick<SectorProductContainerProps, 'formConfigProduct' | 'formDiscountCoupon'>
> = ({ formConfigProduct, formDiscountCoupon }) => {
  const { formData, formErrors, onChangeFormInput } = formConfigProduct;

  return (
    <Fragment>
      <Form
        noValidate={true}
        onSubmit={(e): void => {
          e.preventDefault();
        }}
      >
        <div className="container-event mb-4 p-2">
          <h5 className="mb-2 border-bottom-title mb-5">Taxas de cartão</h5>

          <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda física</p>

          <FormGroup>
            <InputText
              name="physicalSaleDebit"
              label="Débito"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.physicalSaleDebit]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.physicalSaleDebit)(updateMask(e.target.value))
              }
              error={formErrors.physicalSaleDebit && formErrors.physicalSaleDebit[0]}
            />
            <InputText
              name="physicalSaleCredit"
              label="Crédito"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.physicalSaleCredit]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.physicalSaleCredit)(updateMask(e.target.value))
              }
              error={formErrors.physicalSaleCredit && formErrors.physicalSaleCredit[0]}
            />
            <InputText
              name="physicalSalePix"
              label="PIX"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.physicalSalePix]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.physicalSalePix)(updateMask(e.target.value))
              }
              error={formErrors.physicalSalePix && formErrors.physicalSalePix[0]}
            />
            <InputText
              name="physicalSaleAdministrateTax"
              label="Taxa administrativa"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.physicalSaleAdministrateTax]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.physicalSaleAdministrateTax)(
                  updateMask(e.target.value),
                )
              }
              error={
                formErrors.physicalSaleAdministrateTax && formErrors.physicalSaleAdministrateTax[0]
              }
            />
          </FormGroup>
          <div className="d-flex">
            <InstallmentFeesFields
              maxInstallments={24}
              name="physicalSaleInstallmentFees"
              value={formData.physicalSaleInstallmentFees}
              onChange={onChangeFormInput('physicalSaleInstallmentFees')}
              error={formErrors.physicalSaleInstallmentFees?.[0]}
            />
          </div>

          <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda e-commerce</p>

          <FormGroup>
            <InputText
              name="websiteSaleBankSlip"
              label="Boleto"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.websiteSaleBankSlip]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.websiteSaleBankSlip)(updateMask(e.target.value))
              }
              error={formErrors.websiteSaleBankSlip && formErrors.websiteSaleBankSlip[0]}
            />
            <InputText
              name="websiteSaleCredit"
              label="Crédito"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.websiteSaleCredit]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.websiteSaleCredit)(updateMask(e.target.value))
              }
              error={formErrors.websiteSaleCredit && formErrors.websiteSaleCredit[0]}
            />
            <InputText
              name="websiteSalePix"
              label="PIX"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.websiteSalePix]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.websiteSalePix)(updateMask(e.target.value))
              }
              error={formErrors.websiteSalePix && formErrors.websiteSalePix[0]}
            />
            <InputText
              name="websiteSaleAdministrateTax"
              label="Taxa administrativa"
              className="w-input-sm"
              addon="%"
              maxLength={5}
              value={formData[FormInputName.websiteSaleAdministrateTax]}
              placeholder="0"
              onChange={e =>
                onChangeFormInput(FormInputName.websiteSaleAdministrateTax)(
                  updateMask(e.target.value),
                )
              }
              error={
                formErrors.websiteSaleAdministrateTax && formErrors.websiteSaleAdministrateTax[0]
              }
            />
          </FormGroup>
          <div className="d-flex">
            <InstallmentFeesFields
              maxInstallments={24}
              name="websiteSaleInstallmentFees"
              value={formData.websiteSaleInstallmentFees}
              onChange={onChangeFormInput('websiteSaleInstallmentFees')}
              error={formErrors.websiteSaleInstallmentFees?.[0]}
            />
          </div>
          <div className="container-event mb-4">
            <h5 className="mb-2 border-bottom-title mb-5">Cupons e descontos</h5>
          </div>

          <FormGroup>
            <InputText
              name="waiter"
              label="Porcentagem do Garçom"
              addon="%"
              placeholder="0"
              className="w-input-sm"
              maxLength={5}
              value={formData[FormInputName.waiter]}
              onChange={e =>
                onChangeFormInput(FormInputName.waiter)(updateMask(e?.target?.value) as string)
              }
              error={formErrors.waiter && formErrors.waiter[0]}
            />
            <ButtonGroup
              label="Pagamento parcial(rateio)?"
              name="partialPayment"
              value={formData[FormInputName.partialPayment]}
              onChange={e => onChangeFormInput(FormInputName.partialPayment)(e.target.value)}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
              error={formErrors.partialPayment && formErrors.partialPayment[0]}
            />
            <ButtonGroup
              label="Permitir cupom de desconto?"
              name="allowDiscountCoupon"
              value={formData[FormInputName.allowDiscountCoupon]}
              onChange={e => onChangeFormInput(FormInputName.allowDiscountCoupon)(e.target.value)}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
              error={formErrors.allowDiscountCoupon && formErrors.allowDiscountCoupon[0]}
            />
          </FormGroup>
        </div>
      </Form>
      {formData[FormInputName.allowDiscountCoupon] === 'true' ? (
        <RegisterDiscountCoupon formDiscountCoupon={formDiscountCoupon} />
      ) : null}
    </Fragment>
  );
};
